import ReactMarkdown from 'react-markdown';
import Grids from './Grids';
import { STATIC_STRINGS } from '@asez/shared';
import classNames from 'classnames';

function QuestionContainer({ question }) {
  let Response = question.userResponse;
  let testCasesPassed = "N/A";
  let totalTestCases = "N/A";
  let scoresCredited = "N/A";
  let totalTimeTaken = "N/A";
  let testCaseResults;
  let outputGrid = [];

  if (question.userResponse) {
    if (question.userResponse.includes("userCode")) {
      const match = question.userResponse.match(/"userCode"\s*:\s*"([^"]+)"/);
      if (match) {
        Response = match[1].replace(/\\n/g, "\n");
      }
    }
    if (question.userResponse.includes("testCasesPassed")) {
      const match = question.userResponse.match(/"testCasesPassed"\s*:\s*(\d+)/);
      if (match) testCasesPassed = match[1];
    }
    if (question.userResponse.includes("totalTestCases")) {
      const match = question.userResponse.match(/"totalTestCases"\s*:\s*(\d+)/);
      if (match) totalTestCases = match[1];
    }
    if (question.userResponse.includes("scoresCredited")) {
      const match = question.userResponse.match(/"scoresCredited"\s*:\s*(\d+)/);
      if (match) scoresCredited = match[1];
    }
    if (question.userResponse.includes("totalTimeTaken")) {
      const match = question.userResponse.match(/"totalTimeTaken"\s*:\s*([\d.]+)/);
      if (match) totalTimeTaken = match[1];
    }
    if (question.userResponse.includes("submissionResult")) {
      const matches = [...question.userResponse.matchAll(/"description"\s*:\s*"([^"]+)"/g)];
      testCaseResults = matches.map(match => match[1]);
    }
    if (question.userResponse.includes("outputGrid")) {
      const match = question.userResponse.match(/"outputGrid"\s*:\s*(\[\[.*\]\])/);
      if (match) {
        try {
          outputGrid = JSON.parse(match[1]);
        } catch (error) {
          console.error("Error parsing outputGrid:", error);
        }
      }
    }
  }

  const getStatusClass = (status) => {
    const staticStatus = STATIC_STRINGS.CANDIDATE_REPORT_TESTCASES;
    switch (status) {
      case staticStatus.ACCEPTED:
        return "active";
      case staticStatus.REJECTED:
        return "paused";
      default:
        return "";
    }
  };

  return (
    <div>
      <ReactMarkdown>{question.questionStatement}</ReactMarkdown>
      <div className="mt-4 font-mono text-sm bg-gray-100 p-3 rounded overflow-auto">
        <h1 className="text-lg font-semibold">{STATIC_STRINGS.QUESTION_WISE_REPORT_ENUM.QUESTION_RESPONSE}</h1>
        {outputGrid?.length > 0 ? (
          <Grids outputGrid={outputGrid} />
        ) : (
          <>
            <pre className="whitespace-pre-wrap break-words">
              <code>{Response}</code>
            </pre>
            {testCaseResults?.length > 0 && (
              <div className="mt-4 bg-white p-4 rounded shadow">
                <h2 className="text-lg font-semibold">{STATIC_STRINGS.QUESTION_WISE_REPORT_ENUM.TEST_CASES}</h2>
                <p className="text-gray-700">  {testCasesPassed} / {totalTestCases}</p>
                <p className="text-gray-700"> {STATIC_STRINGS.QUESTION_WISE_REPORT_ENUM.SCORE} {scoresCredited}</p>
                <p className="text-gray-700"> {STATIC_STRINGS.QUESTION_WISE_REPORT_ENUM.SCORE} {totalTimeTaken} sec</p>
                <ul className="list-disc pl-5">
                  {testCaseResults.map((description, index) => (
                    <li key={index} className="text-gray-600 my-3 flex items-center">
                      <span>{STATIC_STRINGS.QUESTION_WISE_REPORT_ENUM.TEST_CASE} {index + 1}:</span>
                      <span className={classNames(getStatusClass(description))}>{description}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default QuestionContainer;
